import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 15px;\n  text-align: right;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 15px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  grid-area: containerTotal;\n  padding-top: 1rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  grid-area: discountPrice;\n  color: grey;\n  font-size: 13px;\n  text-align: right;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  grid-area: discountText;\n  color: grey;\n  font-size: 13px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  grid-area: shippingPrice;\n  color: grey;\n  font-size: 13px;\n  text-align: right;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-area: shippingText;\n  color: grey;\n  font-size: 13px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  grid-area: subtotalPrice;\n  color: grey;\n  font-size: 13px;\n  text-align: right;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  grid-area: subtotalText;\n  color: grey;\n  font-size: 13px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  font-size: ", ";\n  grid-template-areas:\n    \"subtotalText subtotalPrice\"\n    ", "\n    ", "\n    \"containerTotal containerTotal\";\n  grid-template-columns: 3.5fr 2fr;\n  grid-gap: 1rem;\n  padding: 1rem 0;\n  border-bottom: 1px solid rgba(50, 50, 50, 0.1);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), function (props) {
  return props.theme.typography.h4FontSize;
}, function (props) {
  return props.showShipping && "\"shippingText shippingPrice\"";
}, function (props) {
  return props.showDiscount && "\"discountText discountPrice\"";
});
export var SubtotalText = styled.div(_templateObject2());
export var SubtotalPrice = styled.div(_templateObject3());
export var ShippingText = styled.div(_templateObject4());
export var ShippingPrice = styled.div(_templateObject5());
export var DiscountText = styled.div(_templateObject6());
export var DiscountPrice = styled.div(_templateObject7());
export var ContainerTotal = styled.div(_templateObject8());
export var TotalText = styled.div(_templateObject9());
export var TotalPrice = styled.div(_templateObject10());